// extracted by css-extract-rspack-plugin
export default {"root":"ybJywX1lsiDBBI8P2EF1K","frame":"i1jfvEXcCv5D7TP7TF2ZJ"};